// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"533":"52ed62c4","663":"75c704c8","713":"7a1a8028","762":"7988551f","932":"700bd4df"}[chunkId] + ".chunk.js";
};